<template>
  <CustomDeleteDialog
    dialogTitle="حذف رسانه"
    dialogId="lesson-media-delete-confirmation-dialog"
    no-close-on-backdrop
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendMediaRemoveRequest"
  >
    <BCol cols="12">
      <p>آیا از حذف رسانه‌ی انتخاب شده اطمینان دارید؟</p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    tempDeleteArray: {
      type: Array,
    },
    tempVideoObject: {
      type: Object,
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendDeleteArvanVideo() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let deleteArvanVideo = new DeleteArvanVideo(_this);
        deleteArvanVideo.setRequestParam({
          videoId: _this.tempVideoObject.arvanCloudVideoId,
        });
        deleteArvanVideo.delete((response) => {
          if (response.isSuccess) {
            _this.sendMediaRemoveRequest();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
    async sendMediaRemoveRequest() {
      if (!this.tempVideoObject || !this.tempVideoObject.arvanCloudVideoId) {
        try {
          this.isOkButtonDisabled = true;
          let _this = this;
          let deleteLessonMedias = new DeleteLessonMedias(_this);
          deleteLessonMedias.setRequestParam({
            lessonId: _this.$route.params.id,
          });
          deleteLessonMedias.setRequestParamDataObj(_this.tempDeleteArray);
          await deleteLessonMedias.fetch(
            (res) => {
              if (res.isSuccess) {
                _this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "حذف شد",
                    text: "رسانه با موفقیت حذف شد",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
                _this.$bvModal.hide("lesson-media-delete-confirmation-dialog");
                _this.$emit("refetch");
              } else {
                _this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "حذف نشد!",
                    icon: "XIcon",
                    variant: "danger",
                    text:
                      res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
                  },
                });
              }
            },
            function (error) {
              console.error(error);
            }
          );
        } catch (error) {
          console.error(error);
        } finally {
          this.isOkButtonDisabled = false;
        }
      } else {
        this.sendDeleteArvanVideo();
      }
    },
  },
  components: {
    BCol,
    CustomDeleteDialog,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { DeleteArvanVideo } from "@/libs/Api/ArvanCloud";
import { DeleteLessonMedias } from "@/libs/Api/Lesson";
import { BCol } from "bootstrap-vue";
</script>
